import React, { useMemo } from 'react';
import { AppButton, Box } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core';
import { useSetupEmployerMode } from '@/modules/employer/components/SetupEmployer/hooks/useSetupEmployerMode';
import { EmployerSetupModes } from '@/modules/employer/employerSetupModes.types';

const ToEditButton = () => {
  const canEditOrganization = useHasAccess([{ permission: Permissions.EDIT_ER_DATA }]);
  const { viewMode, toEdit, mode } = useSetupEmployerMode();
  const isShown = useMemo(() => mode !== EmployerSetupModes.system
    && viewMode && canEditOrganization,
  [mode, viewMode, canEditOrganization]);

  return isShown ? (
    <Box direction="row" align="center">
      <Box width="medium" />
      <Box width="medium">
        <AppButton
          buttonType="secondary"
          onClick={toEdit}
          width="100%"
        >
          {`Edit ${capitalize(mode)}`}
        </AppButton>
      </Box>
    </Box>
  ) : null;
};

export default ToEditButton;
